import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, Select, InputNumber, notification} from 'antd';

import {addFee} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {bindActionCreators} from "redux";
import {formItemLayout} from "../utils/style";
import {getTaxGroups} from "../Tax/actions";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddFeeForm extends Component {
  componentDidMount() {
    const {dispensaryId} = this.props;
    this.props.getTaxGroups({dispensaryId});
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {dispensaryId} = this.props;
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.addFee({...values, dispensaryId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, taxGroups} = this.props;
    return (
      <Card title="Add Fee">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Line item description"
            extra="This is what will be displayed on the cart/receipt"
          >
            {getFieldDecorator('lineItemDescription', {
              initialValue: '',
              rules: [{
                required: true,
                message: 'Line item description is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Tax group"
          >
            {getFieldDecorator('taxGroupId', {
              initialValue: null,
            })(
              <Select>
                <Option key="none" value={null}>NONE</Option>
                {taxGroups.map(({taxGroupId, name}) =>
                  <Option key={taxGroupId} value={taxGroupId}>{name}</Option>
                )}
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Flat rate"
          >
            {getFieldDecorator('flatRate', {
              rules: [{
                required: true,
                message: 'Flat rate is required'
              }, {
                type: 'number',
                min: 0,
                message: 'Flat rate must be a fractional number'
              }]
            })(
              <InputNumber precision={2} step={0.01} />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Add Fee
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddFeeForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispensaryId: PropTypes.string.isRequired,
  addFee: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  getTaxGroups: PropTypes.func.isRequired,
  taxGroups: PropTypes.array.isRequired,
};

const AddFeePage = Form.create()(AddFeeForm);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  loading: state.fee.addingFee,
  taxGroups: state.tax.taxGroups,
});

const mapDispatchToProps = dispatch => ({
  addFee: bindActionCreators(addFee, dispatch),
  getTaxGroups: bindActionCreators(getTaxGroups, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddFeePage);



// WEBPACK FOOTER //
// ./src/Fee/AddFeePage.js